import {FilterOperator, FilterTreeOperator, IczTableDataSource} from '@icz/angular-table';
import {DocumentDto, FileDto} from '|api/document';
import {DEFAULT_SEARCHABLE_ENTITY_TYPES_FILTER, DocumentSearchService} from '|shared';
import {DocumentState, FileState} from '|api/commons';

export enum EntityStateForReclassification {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  BOTH = 'BOTH',
}

export class EntityClassReclassificationObjectsDatasource extends IczTableDataSource<DocumentDto | FileDto> {
  constructor(
    documentSearchService: DocumentSearchService,
    entityStateForReclassification: EntityStateForReclassification,
    entityClassId: number,
    reclassifyObjectsInStoringUnits: boolean,
    reclassifyObjectsInRegistryOffice: boolean,
  ) {
    super(
      searchParams => {
        let allowedDocumentStates: DocumentState[] = [];
        let allowedFileStates: FileState[] = [];

        searchParams.filter.push(
          {
            fieldName: 'issdId',
            value: null,
            operator: FilterOperator.empty
          },
          {
            fieldName: 'entityClassId',
            value: String(entityClassId),
            operator: FilterOperator.equals
          },
          {
            fieldName: 'fileId',
            value: null,
            operator: FilterOperator.empty
          },
        );

        if (!reclassifyObjectsInStoringUnits) {
          searchParams.filter.push(
            {
              fieldName: 'storageUnitId',
              value: null,
              operator: FilterOperator.empty
            },
          );
        }

        if (!reclassifyObjectsInRegistryOffice) {
          searchParams.filter.push(
            {
              fieldName: 'inRegistryOffice',
              value: String(false),
              operator: FilterOperator.equals
            },
          );
        }

        if (entityStateForReclassification === EntityStateForReclassification.OPEN) {
          allowedDocumentStates = [DocumentState.IN_PROGRESS, DocumentState.SUSPENDED];
          allowedFileStates = [FileState.OPEN, FileState.SUSPENDED, FileState.SETTLED];
        } else if (entityStateForReclassification === EntityStateForReclassification.CLOSED) {
          allowedDocumentStates = [DocumentState.SETTLED, DocumentState.DEACTIVATED, DocumentState.EXPORTED];
          allowedFileStates = [FileState.CLOSED, FileState.DEACTIVATED, FileState.EXPORTED];
        } else if (entityStateForReclassification === EntityStateForReclassification.BOTH) {
          allowedDocumentStates = [DocumentState.IN_PROGRESS, DocumentState.SUSPENDED, DocumentState.SETTLED, DocumentState.DEACTIVATED, DocumentState.EXPORTED];
          allowedFileStates = [FileState.OPEN, FileState.SUSPENDED, FileState.SETTLED, FileState.CLOSED, FileState.DEACTIVATED, FileState.EXPORTED];
        }

        searchParams.complexFilter = {
          operator: FilterTreeOperator.OR,
          values: [
            {
              fieldName: 'documentState',
              value: String(allowedDocumentStates),
              operator: FilterOperator.inSet
            },
            {
              fieldName: 'fileState',
              value: String(allowedFileStates),
              operator: FilterOperator.inSet
            }
          ]
        };

        searchParams.fulltextSearchTerm = ' ';

        return documentSearchService.findEntitiesForReclassification(searchParams);
      }
    );

    this.additionalSearchParams = DEFAULT_SEARCHABLE_ENTITY_TYPES_FILTER;
  }
}
